module.exports = __webpack_public_path__ + "static/media/time.31faeb0f.svg";